import { PolicyService } from "./PolicyService";

export type { IPolicyService } from "./IPolicyService";

export const policyService = new PolicyService();
